module.exports = __webpack_public_path__ + "media/images/kontrola-22ea7e9ed949408d1bb9f1255e3812d5.png";